import React from 'react';
import { PRIMARY_500 } from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

export const CheckboxIcon: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%' fill='none'>
        <title>{translated('Accessibility.SvgTitle.checkboxIcon')}</title>
        <g id='service (ea85)'>
            <path
                id='^ Name above ^'
                d='M0.435974 2.18404C0 3.03969 0 4.15979 0 6.4V17.6C0 19.8402 0 20.9603 0.435974 21.816C0.819467 22.5686 1.43139 23.1805 2.18404 23.564C3.03969 24 4.15979 24 6.4 24H17.6C19.8402 24 20.9603 24 21.816 23.564C22.5686 23.1805 23.1805 22.5686 23.564 21.816C24 20.9603 24 19.8402 24 17.6V6.4C24 4.15979 24 3.03969 23.564 2.18404C23.1805 1.43139 22.5686 0.819467 21.816 0.435974C20.9603 0 19.8402 0 17.6 0H6.4C4.15979 0 3.03969 0 2.18404 0.435974C1.43139 0.819467 0.819467 1.43139 0.435974 2.18404ZM7.19808 11.4225L10.0038 14.2855L17.1291 7.02152L18.0778 7.98959L10.0038 16.2285L6.24266 12.3905L7.19808 11.4225Z'
                fill={PRIMARY_500}
            />
        </g>
    </svg>
);
